module.exports = __webpack_public_path__ + "static/media/card-blog7.83608b93.jpg";